"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TwoByTwoMethods = require("./TwoByTwoMethods");
require("./TwoByTwo.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TwoByTwo = props => {
  const {
    content,
    isNested
  } = props;
  const {
    backgroundImages,
    overlappingContent,
    topLeftContent,
    topLeftIsImage,
    topLeftBackgroundColor,
    topRightContent,
    topRightIsImage,
    topRightBackgroundColor,
    bottomLeftContent,
    bottomLeftIsImage,
    bottomLeftBackgroundColor,
    bottomRightContent,
    bottomRightIsImage,
    bottomRightBackgroundColor,
    shortDataPointContent,
    contentfulId
  } = content;

  // forces short data point setting for nested 2x2
  const shortDataPointSetting = isNested ? true : shortDataPointContent;
  const backgroundImageCount = backgroundImages?.length || 0;
  const hasOneBackgroundImage = backgroundImageCount > 0 && backgroundImageCount < 4;
  const hasFourBackgroundImages = backgroundImageCount === 4;
  const hasOvelappingContent = overlappingContent && !backgroundImages?.length;
  const hasShortDataPointContent = shortDataPointSetting && !hasOvelappingContent;
  const hasTopLeftDataPointContent = hasShortDataPointContent || (0, _TwoByTwoMethods.hasContentPoints)(topLeftContent);
  const hasTopRightDataPointContent = hasShortDataPointContent || (0, _TwoByTwoMethods.hasContentPoints)(topRightContent);
  const hasBottomLeftDataPointContent = hasShortDataPointContent || (0, _TwoByTwoMethods.hasContentPoints)(bottomLeftContent);
  const hasBottomRightDataPointContent = hasShortDataPointContent || (0, _TwoByTwoMethods.hasContentPoints)(bottomRightContent);
  const hasDataPointContent = (0, _TwoByTwoMethods.hasContentPoints)(topLeftContent) || (0, _TwoByTwoMethods.hasContentPoints)(topRightContent) || (0, _TwoByTwoMethods.hasContentPoints)(bottomLeftContent) || (0, _TwoByTwoMethods.hasContentPoints)(bottomRightContent);
  const contentProperties = {
    hasOneBackgroundImage,
    hasFourBackgroundImages,
    hasOvelappingContent,
    hasShortDataPointContent,
    hasDataPointContent
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `luna-2x2 ${hasOneBackgroundImage || hasOvelappingContent ? "luna-2x2__one-background-image" : ""} ${hasOvelappingContent ? "luna-2x2__one-background-image--no-background-image" : ""} ${hasFourBackgroundImages ? "luna-2x2__four-background-images" : ""} ${shortDataPointSetting ? "luna-2x2__short-data-point" : ""} ${!hasShortDataPointContent && hasDataPointContent ? "luna-2x2__data-point" : ""}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, (hasOneBackgroundImage || hasFourBackgroundImages) && backgroundImages.map((backgroundImage, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: `2x2-background-image-${backgroundImage?.focalPointImage?.title}-${index}`,
    className: `luna-2x2__${hasOneBackgroundImage ? "one-background-image__background" : `four-background-images__background${index + 1}`}`
  }, (0, _TwoByTwoMethods.renderBackgroundImage)(backgroundImage, hasOneBackgroundImage ? 1 : hasFourBackgroundImages ? 4 : null))), /*#__PURE__*/_react.default.createElement("section", {
    className: `${(0, _TwoByTwoMethods.parseQuadrantClass)("top-left", topLeftBackgroundColor, topLeftIsImage, contentProperties)}`,
    "data-sb-field-path": contentfulId ? "topLeftContent" : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _TwoByTwoMethods.parseContentMargin)(topLeftIsImage, hasTopLeftDataPointContent),
    "data-sb-object-id": topLeftContent ? topLeftContent[0].contentfulId : null
  }, (0, _TwoByTwoMethods.mapQuadrantContent)(topLeftContent, topLeftBackgroundColor, hasShortDataPointContent))), /*#__PURE__*/_react.default.createElement("section", {
    className: `${(0, _TwoByTwoMethods.parseQuadrantClass)("top-right", topRightBackgroundColor, topRightIsImage, contentProperties)}`,
    "data-sb-field-path": contentfulId ? "topRightContent" : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _TwoByTwoMethods.parseContentMargin)(topRightIsImage, hasTopRightDataPointContent),
    "data-sb-object-id": topRightContent ? topRightContent[0].contentfulId : null
  }, (0, _TwoByTwoMethods.mapQuadrantContent)(topRightContent, topRightBackgroundColor, hasShortDataPointContent))), /*#__PURE__*/_react.default.createElement("section", {
    className: `${(0, _TwoByTwoMethods.parseQuadrantClass)("bottom-left", bottomLeftBackgroundColor, bottomLeftIsImage, contentProperties)}`,
    "data-sb-field-path": contentfulId ? "bottomLeftContent" : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _TwoByTwoMethods.parseContentMargin)(bottomLeftIsImage, hasBottomLeftDataPointContent),
    "data-sb-object-id": bottomLeftContent ? bottomLeftContent[0].contentfulId : null
  }, (0, _TwoByTwoMethods.mapQuadrantContent)(bottomLeftContent, bottomLeftBackgroundColor, hasShortDataPointContent))), /*#__PURE__*/_react.default.createElement("section", {
    className: `${(0, _TwoByTwoMethods.parseQuadrantClass)("bottom-right", bottomRightBackgroundColor, bottomRightIsImage, contentProperties)}`,
    "data-sb-field-path": contentfulId ? "bottomRightContent" : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _TwoByTwoMethods.parseContentMargin)(bottomRightIsImage, hasBottomRightDataPointContent),
    "data-sb-object-id": bottomRightContent ? bottomRightContent[0].contentfulId : null
  }, (0, _TwoByTwoMethods.mapQuadrantContent)(bottomRightContent, bottomRightBackgroundColor, hasShortDataPointContent))));
};
var _default = TwoByTwo;
exports.default = _default;